"use client";
import * as amplitude from "@amplitude/analytics-browser";
import { useEffect } from "react";

export function AmplitudeWrapper({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    try {
      amplitude.init("4c301065273b21dc5b7021e7fa174e50", { autocapture: true });
    } catch (error) {
      console.warn("Amplitude initialization failed:", error);
    }
  }, []);

  return <>{children}</>;
}
